import { render, staticRenderFns } from "./DocumentSb.vue?vue&type=template&id=74e31add&scoped=true"
import script from "./DocumentSb.vue?vue&type=script&lang=js"
export * from "./DocumentSb.vue?vue&type=script&lang=js"
import style0 from "./DocumentSb.vue?vue&type=style&index=0&id=74e31add&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e31add",
  null
  
)

export default component.exports